import React from "react";
import { Checkbox, Collapse, Form, Input, Select } from "antd";

const { Option } = Select;

const VehicleData = ({ handleChange, handleSubmit, values, setFieldValue }) => {
  return (
    <div style={{ width: "60%" }}>
      <Form onFinish={handleSubmit}>
        <Collapse
          size="small"
          items={[
            {
              key: "1",
              label: "Routing Preferences",
              children: (
                <>
                  <div className="relay_right_div">
                    <div>
                      <label
                        htmlFor="routeType1"
                        className="form_label_relays "
                      >
                        Route Type
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="routeType1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.routeType}
                        onChange={(value) => {
                          setFieldValue("routeType", value);
                        }}
                      >
                        <Option value="Practical">Practical</Option>
                      </Select>
                    </div>
                    <div>
                      <label
                        htmlFor="roadNetwork1"
                        className="form_label_relays "
                      >
                        Road Network
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="roadNetwork1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.roadNetwork}
                        onChange={(value) => {
                          setFieldValue("roadNetwork", value);
                        }}
                      >
                        <Option value="State + National Network">
                          State + National Network
                        </Option>
                      </Select>
                    </div>
                    <div>
                      <label htmlFor="roads1" className="form_label_relays ">
                        Roads
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="roads1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.roads}
                        onChange={(value) => {
                          setFieldValue("roads", value);
                        }}
                      >
                        <Option value="Highways & Streets<">
                          Highways & Streets
                        </Option>
                      </Select>
                    </div>
                  </div>
                  {/* //second line */}
                  <div className="relay_right_div">
                    <div>
                      <label
                        htmlFor="tollRoads1"
                        className="form_label_relays "
                      >
                        Toll Roads
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="tollRoads1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.tollRoads}
                        onChange={(value) => {
                          setFieldValue("tollRoads", value);
                        }}
                      >
                        <Option value="Discouraged">Discouraged</Option>
                      </Select>
                    </div>
                    <div>
                      <label
                        htmlFor="internationalBorders1"
                        className="form_label_relays "
                      >
                        International Borders
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="internationalBorders1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.internationalBorders}
                        onChange={(value) => {
                          setFieldValue("internationalBorders", value);
                        }}
                      >
                        <Option value="Open">Open</Option>
                      </Select>
                    </div>
                    <div>
                      <label
                        htmlFor="restrictions1"
                        className="form_label_relays "
                      >
                        Restrictions
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="restrictions"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.restrictions}
                        onChange={(value) => {
                          setFieldValue("restrictions", value);
                        }}
                      >
                        <Option value="Use">Use</Option>
                      </Select>
                    </div>
                  </div>
                  {/* Third line */}
                  <div className="relay_right_div">
                    <div>
                      <label htmlFor="ferries1" className="form_label_relays ">
                        Ferries
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="ferries1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.ferries}
                        onChange={(value) => {
                          setFieldValue("ferries", value);
                        }}
                      >
                        <Option value="Discouraged">Discouraged</Option>
                      </Select>
                    </div>
                    <div>
                      <label
                        htmlFor="hubRouting1"
                        className="form_label_relays "
                      >
                        Hub Routing
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="hubRouting1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.hubRouting}
                        onChange={(value) => {
                          setFieldValue("hubRouting", value);
                        }}
                      >
                        <Option value="Disabled">Disabled</Option>
                      </Select>
                    </div>
                    <div>
                      <label
                        htmlFor="sideOfStreetAdherence1"
                        className="form_label_relays "
                      >
                        Side of street Adherence
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="sideOfStreetAdherence1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.sideOfStreetAdherence}
                        onChange={(value) => {
                          setFieldValue("sideOfStreetAdherence", value);
                        }}
                      >
                        <Option value="Off">Off</Option>
                      </Select>
                    </div>
                  </div>
                  {/* Four line */}

                  <div className="relay_right_div">
                    <div>
                      <label
                        htmlFor="governorSpeedLimit1"
                        className="form_label_relays "
                      >
                        Governor Speed Limiting
                      </label>

                      <div className="relay_center">
                        <div style={{ marginRight: "0.5rem" }}>
                          <Select
                            style={{ width: "100px" }}
                            id="governorSpeedLimit1"
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option?.children
                                ?.toLowerCase()
                                ?.indexOf(input?.toLowerCase()) >= 0
                            }
                            value={values.governorSpeedLimit}
                            onChange={(value) => {
                              setFieldValue("governorSpeedLimit", value);
                            }}
                          >
                            <Option value="Enabled">Enabled</Option>
                          </Select>
                        </div>
                        <div style={{ marginRight: "0.2rem" }}>
                          <Input
                            style={{ width: "50px" }}
                            id="longitude1"
                            type="text"
                            name="governorSpeedLimitMPH"
                            value={values.governorSpeedLimitMPH}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              const isNumeric = /^[0-9]*$/;
                              const isBackspace = e.key === "Backspace";
                              const isDot = e.key === ".";
                              if (
                                !(isNumeric.test(e.key) || isBackspace || isDot)
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <p>Mph</p>
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="elevation1"
                        className="form_label_relays "
                      >
                        Elevation
                      </label>

                      <div className="relay_center">
                        <div style={{ marginRight: "0.5rem" }}>
                          <Select
                            style={{ width: "100px" }}
                            id="elevation1"
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option?.children
                                ?.toLowerCase()
                                ?.indexOf(input?.toLowerCase()) >= 0
                            }
                            value={values.elevation}
                            onChange={(value) => {
                              setFieldValue("elevation", value);
                            }}
                          >
                            <Option value="Any">Any</Option>
                          </Select>
                        </div>
                        <div style={{ marginRight: "0.2rem" }}>
                          <Input
                            style={{ width: "65px" }}
                            id="longitude1"
                            type="text"
                            name="elevationFT"
                            value={values.elevationFT}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              const isNumeric = /^[0-9]*$/;
                              const isBackspace = e.key === "Backspace";
                              const isDot = e.key === ".";
                              if (
                                !(isNumeric.test(e.key) || isBackspace || isDot)
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <p>ft</p>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="hazmat1" className="form_label_relays ">
                        Hazmat
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="hazmat1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.hazmat}
                        onChange={(value) => {
                          setFieldValue("hazmat", value);
                        }}
                      >
                        <Option value="None">None</Option>
                      </Select>
                    </div>
                  </div>
                  {/* //five Line */}
                  <div className="relay_right_div">
                    <div>
                      <label
                        htmlFor="siteRouting1"
                        className="form_label_relays "
                      >
                        Site Routing
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="siteRouting1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.siteRouting}
                        onChange={(value) => {
                          setFieldValue("siteRouting", value);
                        }}
                      >
                        <Option value="Disabled">Disabled</Option>
                      </Select>
                    </div>
                    <div style={{ width: "28%" }}>
                      <label
                        htmlFor="terminalMaxDistance1"
                        className="form_label_relays "
                      >
                        Terminal Max Distance
                      </label>
                      <Input
                        id="terminalMaxDistance1"
                        type="text"
                        name="terminalMaxDistance"
                        value={values.terminalMaxDistance}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          const isNumeric = /^[0-9]*$/;
                          const isBackspace = e.key === "Backspace";
                          const isDot = e.key === ".";
                          if (
                            !(isNumeric.test(e.key) || isBackspace || isDot)
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div style={{ width: "28%" }}>
                      <label
                        htmlFor="pilotMaxDistance1"
                        className="form_label_relays "
                      >
                        Pilot Max Distance
                      </label>
                      <Input
                        id="pilotMaxDistance1"
                        type="text"
                        name="pilotMaxDistance"
                        value={values.pilotMaxDistance}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          const isNumeric = /^[0-9]*$/;
                          const isBackspace = e.key === "Backspace";
                          const isDot = e.key === ".";
                          if (
                            !(isNumeric.test(e.key) || isBackspace || isDot)
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ width: "28%" }}>
                    <label
                      htmlFor="terminalMaxHours1"
                      className="form_label_relays "
                    >
                      Max Drive Time(Hours)
                    </label>
                    <Input
                      id="terminalMaxHours1"
                      type="text"
                      name="terminalMaxHours"
                      value={values.terminalMaxHours}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        const isNumeric = /^[0-9]*$/;
                        const isBackspace = e.key === "Backspace";
                        const isDot = e.key === ".";
                        if (!(isNumeric.test(e.key) || isBackspace || isDot)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "2rem",
                    }}
                  ></div>
                </>
              ),
            },
            {
              key: "2",
              label: "Vehicle Dimensions",
              children: (
                <>
                  <div className="relay_right_div">
                    <div>
                      <label
                        htmlFor="vehicleType1"
                        className="form_label_relays "
                      >
                        Vehicle Type
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="vehicleType"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.vehicleType}
                        onChange={(value) => {
                          setFieldValue("vehicleType", value);
                        }}
                      >
                        <Option value="Truck">Truck</Option>
                      </Select>
                    </div>
                  </div>
                  {/* second line */}
                  <div className="relay_right_div">
                    <div>
                      <label htmlFor="heightFT1" className="form_label_relays ">
                        Height
                      </label>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ marginRight: "0.2rem" }}>
                          <Input
                            style={{ width: "100px" }}
                            id="heightFT1"
                            type="text"
                            name="heightFT"
                            value={values.heightFT}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              const isNumeric = /^[0-9]*$/;
                              const isBackspace = e.key === "Backspace";
                              const isDot = e.key === ".";
                              if (
                                !(isNumeric.test(e.key) || isBackspace || isDot)
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <p style={{ marginRight: "1rem" }}>ft</p>
                        <div style={{ marginRight: "0.2rem" }}>
                          <Input
                            style={{ width: "100px" }}
                            id="heightIN1"
                            type="text"
                            name="heightIN"
                            value={values.heightIN}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              const isNumeric = /^[0-9]*$/;
                              const isBackspace = e.key === "Backspace";
                              const isDot = e.key === ".";
                              if (
                                !(isNumeric.test(e.key) || isBackspace || isDot)
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <p>in</p>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="lengthFT1" className="form_label_relays ">
                        Length
                      </label>

                      <div className="relay_center">
                        <div style={{ marginRight: "0.2rem" }}>
                          <Input
                            style={{ width: "100px" }}
                            id="lengthFT1"
                            type="text"
                            name="lengthFT"
                            value={values.lengthFT}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              const isNumeric = /^[0-9]*$/;
                              const isBackspace = e.key === "Backspace";
                              const isDot = e.key === ".";
                              if (
                                !(isNumeric.test(e.key) || isBackspace || isDot)
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <p style={{ marginRight: "1rem" }}>ft</p>
                        <div style={{ marginRight: "0.2rem" }}>
                          <Input
                            style={{ width: "100px" }}
                            id="longitude1"
                            type="text"
                            name="lengthIN"
                            value={values.lengthIN}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              const isNumeric = /^[0-9]*$/;
                              const isBackspace = e.key === "Backspace";
                              const isDot = e.key === ".";
                              if (
                                !(isNumeric.test(e.key) || isBackspace || isDot)
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <p>in</p>
                      </div>
                    </div>
                  </div>
                  {/* //third line */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "1rem",
                    }}
                  >
                    <div>
                      <label htmlFor="width1" className="form_label_relays ">
                        Width
                      </label>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Input
                          style={{ width: "150px" }}
                          id="width1"
                          type="text"
                          name="width"
                          value={values.width}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            const isNumeric = /^[0-9]*$/;
                            const isBackspace = e.key === "Backspace";
                            const isDot = e.key === ".";
                            if (
                              !(isNumeric.test(e.key) || isBackspace || isDot)
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <p style={{ marginLeft: "0.2rem" }}>in</p>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="weight1" className="form_label_relays ">
                        Weight
                      </label>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Input
                          style={{ width: "150px" }}
                          id="weight1"
                          type="text"
                          name="weight"
                          value={values.weight}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            const isNumeric = /^[0-9]*$/;
                            const isBackspace = e.key === "Backspace";
                            const isDot = e.key === ".";
                            if (
                              !(isNumeric.test(e.key) || isBackspace || isDot)
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                        <p style={{ marginLeft: "0.2rem" }}>lbs</p>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="axies1" className="form_label_relays ">
                        Axies
                      </label>
                      <Select
                        style={{ width: "200px" }}
                        id="axies1"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={values.axies}
                        onChange={(value) => {
                          setFieldValue("axies", value);
                        }}
                      >
                        <Option value="5">5</Option>
                      </Select>
                    </div>
                  </div>
                  {/* four line */}
                  <div className="relay_right_div">
                    <div>
                      <Checkbox
                        checked={values.multipleTrailer}
                        onChange={(e) =>
                          setFieldValue("multipleTrailer", e.target.checked)
                        }
                      >
                        Multiple Trailer (MT)
                      </Checkbox>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "2rem",
                    }}
                  ></div>
                </>
              ),
            },
          ]}
          // defaultActiveKey={["1"]}
        />
      </Form>
    </div>
  );
};

export default VehicleData;
